module.exports = __webpack_public_path__ + "img/layout_top.775f8844.svg";